export default __webpack_public_path__ + "static/media/card_bg.58811c2d.jpg";